
import React, { Fragment, useMemo, useState } from 'react'
import { Alert } from 'react-bootstrap'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'

import InternalProfilesCreator from './InternalProfilesCreator'
import InternalProfilesTabItem from './InternalProfilesTabItem'

import './InternalProfilesTab.scss'

const InternalProfilesTab = () => {

  const { t } = useTranslation()

  const { teamSelected, allInternalProfiles } = useTeams()

  const [ showInternalProfilesCreator, setShowInternalProfilesCreator ] = useState(false)

  const profiles = useMemo(() => {

    return allInternalProfiles.map((profile: any) => {

    return {
      ...profile,
      isInTeam: teamSelected.internalProfiles.find((p: any) => p._id === profile._id)
    }
  })
  }, [ allInternalProfiles, teamSelected ])

  return (
    <Fragment>
      <div className="internal-profiles-tab mb-2">
        <div>
          <Alert variant="info" style={{ borderRadius: '.25rem' }}>
            {t('TEAMMEMBER_SELECTOR:InternalProfilesTabAlert')}
          </Alert>
        </div>

        <button className='submit-button' onClick={() => setShowInternalProfilesCreator(true)}>
          <span className="icon-agregar_colaborador"></span>
          <span className="button-text">
            {' ' + t('TEAMMEMBER_SELECTOR:CreateInternalProfile')}
          </span>
        </button>
      </div>
      <div className='scroller' style={{ height: 'auto', maxHeight: '72vh' }}>
        {profiles.map((profile: any, i: number) => (
          <InternalProfilesTabItem key={profile._id} profile={profile} />
        ))}
      </div>

      <InternalProfilesCreator
        show={showInternalProfilesCreator}
        onHide={() => setShowInternalProfilesCreator(false)}
      />
    </Fragment>
  )
}

export default InternalProfilesTab
